import type { Components, Theme } from "@mui/material";

import { IconChevronDown } from "@dfp/react-icons";

export const fidooSelect: Components<Theme>["MuiSelect"] = {
  defaultProps: {
    variant: "filled",
    disableUnderline: true,
    IconComponent: IconChevronDown,
    MenuProps: {
      PaperProps: {
        elevation: 0,
        sx: {
          maxHeight: 400,
          marginTop: (theme) => theme.spacing(0.5),
          borderRadius: (theme) => theme.borderRadius.xs,
          border: (theme) => `1px solid ${theme.palette.custom.border}`,
          boxShadow: (theme) => theme.customShadows.dropdown,
        },
      },
    },
  },
  styleOverrides: {
    icon: ({ theme }) => ({
      width: "20px",
      height: "20px",
      top: "calc(50% - 10px)",
      color: theme.palette.custom.icon,
      fill: "none",
    }),
  },
};
